
import axiosInstance from "../api/axios";
import { createContext } from "react";

export const AdminContext = createContext();


const getHeaders = () => {
  const token = localStorage.getItem("token");

  if (!token) return {};

  return {
    Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}`,
  };
};


async function getAdminDashboard() {
  try {
    const res = await axiosInstance.get("/stats/admin", {
      headers: getHeaders(),
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching admin dashboard:", error);
    return null;
  }
}

export default function AdminContextProvider({ children }) {
  return (
    <AdminContext.Provider value={{ getAdminDashboard }}>
      {children}
    </AdminContext.Provider>
  );
}
